import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var soTotlaRes;
export const soTotlaTodo = createAsyncThunk('soTotla', async (data) => {


    var type = localStorage.getItem('type')
    try {
        const res = await axios({
            method: "post",
            url: process.env.REACT_APP_API_URL + 'dashboard_so_total',
            headers: { "Content-Type": "application/json" },
            data:
            {
                "vcust_plant_code": localStorage.getItem('vcust_plant_code')
            }
        })
        return soTotlaRes = res.data

    } catch (error) {
        return soTotlaRes = error.response.data
    }
});

const soTotlaSlice = createSlice({
    name: 'soTotla',
    initialState: {
        data: null,
    },
    extraReducers: (builder) => {
        builder.addCase(soTotlaTodo.fulfilled, (state, action) => {
            state.data = action.payload;
            // console.log('userList', state.data)
        });
        builder.addCase(soTotlaTodo.rejected, (state, action) => {
            // console.log('token_error', action)
        })
    }
});

export default soTotlaSlice.reducer; 